// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_99-0";
export var headerCellHover = "_99-1";
export var readCellContainer = "_99-2";
export var readCellSlot = "_99-3";
export var rowHoverCheckbox = "_99-4";
export var rowUnreadIndicator = "_99-5";
export var searchHighlight = "_99-8";
export var supportTicketRow = "_99-6";
export var unreadIndicator = "_99-7";